<template>
  <div class="CustomeServicePopup" v-if="aftercustomerPopupActive">
    <div class="customer-popup-box">
      <router-link to="/activity/goods_bargain" class="popup-img-wrap">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/a9b25202205311820028216.png" alt="" width="100%">
      </router-link>
      <div class="close">
        <img 
          @click="close"
          src="@assets/images/popup-close.png">
      </div>
    </div>
    <!-- <div class="customer-popup-box">
      <div class="customer-popup-title">识别此二维码添加售后客服</div>
      <img src="@assets/images/after_qrcode.png">
      <div 
        class="close-popup"
        @click="close"
        >确定</div>
    </div> -->
    <div
      class="mask"
      @touchmove.prevent
      v-show="aftercustomerPopupActive"
    ></div>
  </div>
</template>

<script>
export default {
  name: "BargainingPopup",
  props: {
    aftercustomerPopupActive:{
      type:Boolean,
      default:false
    },
    lottery:{
      type:Object,
      default(){
        return{}
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    close:function(){
      
      this.$emit("closeBargainPopup", false);
      console.log(777)
    }
  }
};
</script>

<style scoped>
.CustomeServicePopup .customer-popup-box{
  position: fixed;
  width: 80%;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  text-align: center;
  /* background: #fff; */
  border-radius: .2rem;
  /* padding-top: .7rem; */
}
.CustomeServicePopup .customer-popup-title{
  font-size: .34rem;
  font-weight: 500;
  padding-bottom: .32rem;
}
.CustomeServicePopup .close-popup{
  margin-top: .6rem;
  padding: .4rem 0;
  font-size: .32rem;
  border-top: .02rem solid #e4e4e4;
  color: #576B95;
  font-weight: 700;
}
.popup-img-wrap{
  display: block;
}
.close{
  opacity: .3;
}
.mask{
  z-index: 999;
}
</style>
